import FetchFactory from '@repository/factory';
import Routes from '@repository/routes.client';
import type { LocationQueryValue } from 'vue-router';
import type { PaginationParams } from '@composables/usePagination';
import type {
    PastEventsResponse,
    UpcomingEventsResponse,
    EventCredentialsResponse,
} from '@repository/types';

class EventModule extends FetchFactory {
    private readonly RESOURCE = Routes.Event;

    getEventCredentials(
        eventId: MaybeRef<LocationQueryValue | LocationQueryValue[]>
    ) {
        return this.call<EventCredentialsResponse>({
            url: `${this.RESOURCE.credentials(eventId)}`,
            method: 'GET',
        });
    }

    getUpcomingEvents(params: ComputedRef<PaginationParams>) {
        return this.call<UpcomingEventsResponse>({
            url: `${this.RESOURCE.upcomingEvents()}`,
            method: 'GET',
            fetchOptions: {
                params: toValue(params),
            },
        });
    }

    getPastEvents(params: ComputedRef<PaginationParams>) {
        return this.call<PastEventsResponse>({
            url: `${this.RESOURCE.pastEvents()}`,
            method: 'GET',
            fetchOptions: {
                params: toValue(params),
            },
        });
    }
}

export default EventModule;
